import { apolloClient } from '@/lib/apollo';

import { appStore } from '@/store';
import { IS_GUEST_MEMBER_BENEFITS_ELIGIBLE_QUERY } from '../graphql';
import { features, getGlobals, getLocale, getToken } from '@/lib';
import {
  getBankPayload,
  getCardPayload,
  getDialingCode,
  serializeAddressFields,
} from '../utils';

/**
 * Serlizes data to be used in eligiblity query and use benefits mutation
 * @param {object} data // Form state
 * @returns {object}
 */
export const serializeDataForMemberBenefits = data => {
  const {
    email: { value: email },
    firstName: { value: firstName },
    lastName: { value: lastName },
    phone: { value: number },
    phoneType: { value: phoneType },
  } = data;
  const dialingCode = getDialingCode(data);

  return {
    ...getBankPayload(data),
    ...getCardPayload(data),
    country: getLocale().country,
    email: email.trim(),
    firstName: firstName.trim(),
    lastName: lastName.trim(),
    phone: {
      countryCode: `${dialingCode}`,
      number,
      type: phoneType,
    },
    supportedThreeDsExperiences: [features.get('threeDsV1Experience')],
    token: getToken(),
    ...serializeAddressFields(data),
  };
};

/**
 * Calls GQL query to see if this user matches a member account
 * @param {object} data // Form state
 * @returns {object}
 */
export const checkMemberBenefits = async data => {
  try {
    const {
      ui: { checkForMemberBenefits, fiType },
    } = appStore.getState();
    const { api: apiActions } = appStore.getActions();
    const isGuest = features.isActive('isForcedGuest');
    const isForcedSignUp = features.isActive('isForcedSignUp');
    const isGuestEligible =
      getGlobals()?.initialGqlData?.checkoutSession?.flags?.isGuestEligible;
    const isBNPL = features.get('bnplExperience') && fiType === 'bnpl';
    if (
      (isGuest || isGuestEligible || isForcedSignUp) &&
      checkForMemberBenefits &&
      !isBNPL
    ) {
      const variables = serializeDataForMemberBenefits(data);

      const isMemberEligible = await apolloClient.query({
        query: IS_GUEST_MEMBER_BENEFITS_ELIGIBLE_QUERY,
        variables,
      });

      const isEligible = Boolean(
        isMemberEligible?.data?.isGuestMemberBenefitsEligible?.isEligible,
      );
      apiActions.setIsEligibleForMemberBenefits(isEligible);

      return isEligible;
    }

    return false;
  } catch (err) {
    return false;
  }
};
